import classnames from 'classnames';
import React, { useState } from 'react';
import CommentsPanel from '~/components/comments_panel';
import { useUser } from '~/providers/user';
import Permissions from '~/settings/permissions';
import { useProjectDocumentComparison } from '../providers/project_document_comparison';
const ComparisonCommentsPanelButton = () => {
    const { documentsComparisonDetail } = useProjectDocumentComparison();
    const [showComparisonComment, setShowComparisonComment] = useState(false);
    const { hasPermission } = useUser();
    if (!hasPermission(Permissions.VIEW_COMPARISON_COMMENTS)) {
        return React.createElement(React.Fragment, null);
    }
    const className = classnames('comparison-comments-svg', { active: showComparisonComment });
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { className: className, onClick: () => setShowComparisonComment(true) },
            React.createElement("i", { className: 'fa-comments fas fa-fw' })),
        showComparisonComment && documentsComparisonDetail &&
            React.createElement(CommentsPanel, { comparisonDetail: documentsComparisonDetail, onHide: () => setShowComparisonComment(false) })));
};
export default ComparisonCommentsPanelButton;
